import React, { useState } from "react";
import { useParams } from "react-router";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import { useProject } from "../../../contexts/project";
import FavouriteReportActions from "../../../views/favoriteReport/FavouriteReportActions";

export default function ReportsTable({ favoriteReports, displayAll = false, search = "" }) {
  const { clientId } = useParams();
  const currentProject = useProject();
  const currentClientId = clientId || currentProject?.client?.id;
  const [selected, setSelected] = useState(null);

  const filteredReports = search
    ? favoriteReports.filter((report) =>
        (report?.payload?.name || "").toLowerCase().includes(search.toLowerCase())
      )
    : favoriteReports;

  if (favoriteReports.length === 0) {
    return (
      <Box p={4} textAlign="center">
        <Typography variant="body1" color="textSecondary">
          There are no current favorite reports set up
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Report Template Name</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredReports.map((row) => (
            <TableRow
              key={row.id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              hover
              selected={selected === row.id}
              onClick={() => setSelected(row.id)}
            >
              <TableCell component="th" scope="row">
                {row.payload.name}
              </TableCell>
              <TableCell align="right">
                <FavouriteReportActions
                  entity={row}
                  selectedProjectId={currentProject?.id}
                  selectedClientId={currentClientId}
                  showSettings={false}
                  duplicateLabel="Duplicate and Edit Template"
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
